import { Navigate, useLocation } from "react-router-dom";
import { hasFullPermission, isSuperAdminRole } from "./helper";

const FullProtectedRoutes = ({
    permission = "view",
    subModule,
    mainModule = "maintenance",
    fallbackMainModule,
    fallbackSubModule,
    children
}) => {
    const location = useLocation();
    const userDetails = JSON.parse(localStorage.getItem("fms-maintenance-details"));

    if (!userDetails) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    if (isSuperAdminRole(userDetails?.my_role)) {
        return children;
    }

    let hasAccess = hasFullPermission({
        permissionSlug: permission,
        menuSlug: subModule,
        moduleSlug: mainModule
    });

    if (!hasAccess && fallbackMainModule && fallbackSubModule) {
        hasAccess = hasFullPermission({
            permissionSlug: permission,
            menuSlug: fallbackSubModule,
            moduleSlug: fallbackMainModule
        });
    }

    return hasAccess ? children : <Navigate to="/no-access" replace />;
};

export default FullProtectedRoutes;
